import { atom } from "recoil";

export const DataDoanhNghiepState = atom({
  key: "DataDoanhNghiepState",
  default: null,
});
